module.exports = __webpack_public_path__ + "img/video-player/fullscreen-ff1f930b3bf0f81ef2988a027bb2d251.svg";